if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.form) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form) return;

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.setAttribute("disabled", "true");
          submitButton.classList.add("loading");
        }

        // Get Cart API
        let config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const cartNotification = document.querySelector("cart-notification");
        const cartItems = document.querySelector("cart-items");

        let formData = new FormData(this.form);
        if (cartNotification && typeof cartNotification.getSectionsToRender === "function") {
          formData.append(
            "sections",
            cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          if (typeof cartNotification.setActiveElement === "function") {
            cartNotification.setActiveElement(document.activeElement);
          }
        }

        if (cartItems && typeof cartItems.getSectionsToRender === "function") {
          formData.append(
            "sections",
            cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            return response.json();
          })
          .then((parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              return;
            }
            if (cartNotification && typeof cartNotification.renderContents === "function") {
              cartNotification.renderContents(parsedState);
            }

            if (cartItems && typeof cartItems.renderContents === "function") {
              cartItems.renderContents(parsedState);
            }

            document.querySelector(".product-form__error-message-wrapper")?.classList.add("no-js-inline");
          })
          .catch((e) => {
            console.error("Product add-to-cart error:", e);
          })
          .finally(() => {
            if (submitButton) {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");
            }
            if (typeof closeQuickView === "function") {
              closeQuickView();
            } else {
              const quickView = document.getElementById("quickViewWrapper");
              if (quickView) {
                quickView.classList.remove("show__modal");
                quickView.innerHTML = "";
              }
              document.body.classList.remove("overflow-hidden");
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.remove("no-js-inline");
        }
      }
    }
  );
}
